import React, { useContext, useEffect, useState } from 'react';
import { Table } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { OrderDirection, PagesFilterResponse } from '../../Models/Models';
import { SiteContext } from '../../Contexts';
import { EntityColors } from '../../Themes/EntityColors';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFont, faImage, faListOl } from '@fortawesome/free-solid-svg-icons';
import { Utils } from '../../Services/Utils';
import { PageService } from '../../Services/PageService';
import TableShell from '../Table/TableShell';
import TableToolbar from '../Table/TableToolbar';

const PageTableComponent = () => {
    useEffect(() => {
        Utils.setDocumentTitle('Stránky');
    }, []);

    const { filterPages } = PageService();
    const [response, setResponse] = useState<PagesFilterResponse | null>(null);
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(6);
    const [orderDirection, setOrderDirection] = useState<OrderDirection>('Desc');
    const { currentSite }: any = useContext(SiteContext);
    const { action, icon } = EntityColors.page;

    const loadPage = async (pageNum: number, opts?: { perPage?: number; order?: OrderDirection }) => {
        const limit = opts?.perPage ?? perPage;
        const resp = await filterPages({
            websiteId: currentSite.id,
            limit,
            offset: (pageNum - 1) * limit,
            orderDirection: opts?.order ?? orderDirection,
        });
        setResponse(resp ?? null);
    };

    const changePerPage = (count: number) => {
        setPerPage(count);
        setPage(1);
        void loadPage(1, { perPage: count });
    };

    const changeOrder = (dir: OrderDirection) => {
        setOrderDirection(dir);
        setPage(1);
        void loadPage(1, { order: dir });
    };

    useEffect(() => {
        setPage(1);
        void loadPage(1);
    }, [currentSite]);

    return (
        <TableShell
            title="Stránky"
            icon={icon}
            accentColor={action}
            isLoading={response === null}
            isEmpty={response !== null && response.data.length === 0}
            emptyMessage="Žiadne stránky"
            page={page}
            totalCount={response?.totalCount}
            perPage={perPage}
            onPageChange={p => { setPage(p); loadPage(p); }}
            headerActions={
                <>
                    <Link to="/text/table" className="st-btn st-btn--outline">
                        <FontAwesomeIcon icon={faFont} className="st-table-shell-create-icon" />
                        Všetky texty
                    </Link>
                    <Link to="/pageimage/table" className="st-btn st-btn--outline">
                        <FontAwesomeIcon icon={faImage} className="st-table-shell-create-icon" />
                        Všetky obrázky
                    </Link>
                </>
            }
            toolbar={
                <TableToolbar
                    totalCount={response?.totalCount ?? 0}
                    nounForms={['stránka', 'stránky', 'stránok']}
                    perPage={perPage}
                    onPerPageChange={changePerPage}
                    orderDirection={orderDirection}
                    onOrderChange={changeOrder}
                />
            }
        >
            <Table responsive>
                <thead>
                    <tr>
                        <th>Kód stránky</th>
                        <th className="text-center">Akcie</th>
                    </tr>
                </thead>
                <tbody>
                    {response?.data.map(p => (
                        <tr key={p.id}>
                            <td className="fw-medium">{p.code}</td>
                            <td className="text-center">
                                <div className="st-page-actions" style={{ '--btn-accent': action } as React.CSSProperties}>
                                    <Link to={`/section/table/${p.id}`} className="st-btn st-btn--sm st-btn--fill">
                                        <FontAwesomeIcon icon={faListOl} className="st-page-actions__icon" />
                                        Sekcie
                                    </Link>
                                    <Link to={`/text/table/${p.id}`} className="st-btn st-btn--sm st-btn--tint">
                                        <FontAwesomeIcon icon={faListOl} className="st-page-actions__icon" />
                                        Texty
                                    </Link>
                                    <Link to={`/pageimage/table/${p.id}`} className="st-btn st-btn--sm st-btn--tint">
                                        <FontAwesomeIcon icon={faImage} className="st-page-actions__icon" />
                                        Obrázky
                                    </Link>
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </TableShell>
    );
};

export default PageTableComponent;
